import React from 'react';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';
import DayLabelFields from 'components/actionBar/ActionBarCalendar/components/DayLabelFields';
import Switch from 'components/common/Switch';
import { getCalendarSettings } from 'constants/calendarSettings';
import c from '../CalendarGrid.module.scss';
import SettingsSection from '../SettingsSection';

/**
 * @param {Object} props
 * @param {import('actions/scene.types').CalendarShape} props.calendar Calendar shape being edited.
 * @param {import('actions/scene.types').CalendarShapeChangeHandler} props.onChange Applies a partial calendar update.
 * @returns {React.ReactElement}
 */
const WeekdayNamesSection = ({ calendar, onChange }) => {
  const weekdayNamePadding = getCalendarSettings(calendar).WeekdayNameShape.margin;
  /** @type {(keyof import('constants/calendarSettings').Margin)[]} */
  const paddingSides = ['left', 'right', 'top', 'bottom'];

  return (
    <SettingsSection title="Weekday names">
      <DayLabelFields shape={calendar} onChange={onChange} className={c.typographyFields} />
      <div>
        <div className={c.fieldLabel}>Padding</div>
        {paddingSides.map((side) => (
          <label key={side} className={c.field}>
            <span>{side.charAt(0).toUpperCase() + side.slice(1)}</span>
            <input
              type="number"
              min="0"
              step="any"
              value={weekdayNamePadding[side]}
              onChange={(event) => {
                const value = Number(event.target.value);
                onChange({
                  weekdayNamePadding: {
                    ...weekdayNamePadding,
                    [side]: Number.isFinite(value) ? Math.max(0, value) : 0,
                  },
                });
              }}
            />
          </label>
        ))}
      </div>
      <div className={c.debugSettingRow}>
        <Switch
          id="calendar-weekday-debug-guides"
          className={c.debugSwitch}
          checked={calendar.showWeekdayNameDebugGuides === true}
          onChange={() => onChange({ showWeekdayNameDebugGuides: calendar.showWeekdayNameDebugGuides !== true })}
          label="Show debug guides"
          aria-label="Show weekday name debug guides"
        />
        <button
          type="button"
          className={c.infoButton}
          aria-label="About weekday name debug guides"
          data-for="calendarWeekdayDebugGuidesTooltip"
          data-tip="Shows dashed boundaries of the weekday-name area after padding, for debugging in admin mode. These guides are not part of the final design."
        >
          <FontAwesomeIcon.Memo icon={faCircleInfo} />
        </button>
        <ReactTooltip id="calendarWeekdayDebugGuidesTooltip" place="right" type="dark" effect="solid" />
      </div>
    </SettingsSection>
  );
};

export default WeekdayNamesSection;
